import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'

import * as styles from './ClampingTextButtonTail.module.css'

import EditIcon from '../../../icons/edit.svg'

function ClampingTextButtonTail({
  canEdit,
  containerClassName = styles.container,
  tooltip,
  onClick,
}) {
  const { t } = useTranslation()

  return canEdit ? (
    <div className={containerClassName}>
      <Button.Outlined
        isGrey
        beforeIconProps={{ Icon: EditIcon }}
        height={BUTTON_HEIGHT_32}
        tooltip={tooltip || t('Common.ClampingTextEditBtnTooltipKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={onClick}
      />
    </div>
  ) : null
}

export default ClampingTextButtonTail
